import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import EDSFooter from '../components/EDSFooter';
import ProfileHeader from '../components/ProfileHeader';
import * as globals from '../globals.js';
import ApiService from '../services/ApiService';
import { useSelector } from 'react-redux';

const Karta_platnicza_dodano = (props) => {

    const apiService = ApiService.getInstance();
    const [obligatoryDataProvided, setObligatoryDataProvided] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cardData, setCardData] = useState(false);
    let dateToBay = useSelector((state) => state.repos.chName);
    const history = useHistory();

    useEffect(() => {
        const error = () => {
            history.push('/karta_platnicza_error');
        };

        if (
            typeof props.match.params.sessionId === 'string' &&
            props.match.params.sessionId.length > 0
        ) {
            loadData((success) => {
                if (typeof success === 'boolean' && success) {
                    setObligatoryDataProvided(true);
                } else {
                    // problem podczas pobierania danych dodanej karty
                    error();
                }
            });
        } else {
            error();
        }
    }, []);

    function loadData(callback) {
        const maxTries = 10;
        const retrySeconds = 5; //second
        const getData = (callback) => {
            const payload = { sessionID: props.match.params.sessionId };
            apiService.apiPost('GetUserCardBySessionId', payload, (response) => {
                if (response.success) {
                    if (
                        typeof response.data.cardType === 'string' &&
                        response.data.cardType.length > 0 &&
                        typeof response.data.mask === 'string' &&
                        response.data.mask.length > 0 &&
                        typeof response.data.paymentCardID === 'number' &&
                        response.data.paymentCardID > 0
                    ) {
                        setCardData(response.data);
                        if (typeof callback === 'function') callback(true);
                    } else {
                        if (typeof callback === 'function') callback(false);
                    }
                } else {
                    if (typeof callback === 'function') callback(false);
                }
            });
        };

        const getCardStatus = (callback, tryNumber = 1) => {
            if (tryNumber < maxTries) {
                const currentTryLoaderTaskId = apiService.startLoaderTask({
                    label:
                        'Proszę czekać - trwa aktualizacja statusu karty w systemie' +
                        (tryNumber > 1 ? ' (' + tryNumber + ')' : ''),
                });
                getData((success) => {
                    apiService.stopLoaderTask(currentTryLoaderTaskId);
                    if (success) {
                        callback(true);
                    } else {
                        tryNumber++;
                        setTimeout(() => {
                            getCardStatus(callback, tryNumber);
                        }, retrySeconds * 1000);
                    }
                });
            } else {
                callback(false);
            }
        };

        setLoading(true);
        const mainLoaderTaskId = apiService.startLoaderTask();
        getCardStatus((success) => {
            setLoading(false);
            apiService.stopLoaderTask(mainLoaderTaskId);
            callback(success);
        });
    }

    function render() {
        return (
            <>
                <header className="header">
                    <div className="header__image-box">
                        <a href="">
                            <img
                                src={logo_pop}
                                alt="Logo Egurrola Dance Studio"
                                className="header__image"
                            />
                        </a>
                    </div>
                    <div className="header__caption-box">
                        <span className="header__caption">Proces zakupu kursu</span>
                    </div>
                </header>
                <div className="content">
                    <ProfileHeader></ProfileHeader>
                    <main className="responsive-padding margin-top-32">
                        <div className="row-align-items-center">
                            <svg
                                className="credit-card-icon"
                                viewBox="0 0 28 28"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M2.33334 8.16602C2.33334 7.23776 2.70209 6.34752 3.35847 5.69114C4.01485 5.03476 4.90509 4.66602 5.83334 4.66602H22.1667C23.0949 4.66602 23.9852 5.03476 24.6416 5.69114C25.2979 6.34752 25.6667 7.23776 25.6667 8.16602V19.8327C25.6667 20.7609 25.2979 21.6512 24.6416 22.3076C23.9852 22.9639 23.0949 23.3327 22.1667 23.3327H5.83334C4.90509 23.3327 4.01485 22.9639 3.35847 22.3076C2.70209 21.6512 2.33334 20.7609 2.33334 19.8327V8.16602ZM5.83334 6.99935C5.52392 6.99935 5.22718 7.12227 5.00839 7.34106C4.78959 7.55985 4.66668 7.8566 4.66668 8.16602V9.33268H23.3333V8.16602C23.3333 7.8566 23.2104 7.55985 22.9916 7.34106C22.7728 7.12227 22.4761 6.99935 22.1667 6.99935H5.83334ZM23.3333 11.666H4.66668V19.8327C4.66668 20.1421 4.78959 20.4388 5.00839 20.6576C5.22718 20.8764 5.52392 20.9993 5.83334 20.9993H22.1667C22.4761 20.9993 22.7728 20.8764 22.9916 20.6576C23.2104 20.4388 23.3333 20.1421 23.3333 19.8327V11.666ZM7.00001 15.166C7.00001 14.8566 7.12293 14.5598 7.34172 14.3411C7.56051 14.1223 7.85726 13.9993 8.16668 13.9993H14C14.3094 13.9993 14.6062 14.1223 14.825 14.3411C15.0438 14.5598 15.1667 14.8566 15.1667 15.166C15.1667 15.4754 15.0438 15.7722 14.825 15.991C14.6062 16.2098 14.3094 16.3327 14 16.3327H8.16668C7.85726 16.3327 7.56051 16.2098 7.34172 15.991C7.12293 15.7722 7.00001 15.4754 7.00001 15.166Z" />
                            </svg>
                            <h2 className="h2">Karta płatnicza</h2>
                        </div>

                        {renderCardData()}
                    </main>
                </div>
                <EDSFooter></EDSFooter>
            </>
        );
    }

    function renderCardData() {
        if (loading) {
            return <></>;
        } else {
            const btn = (txt) => {
                if(dateToBay){
                    return (
                   
                        <Link to="/wybor_opcji_4_forma_platnosci">
                            <a href="" className="btn-primary-responsive margin-top-64">
                                {txt}
                            </a>
                        </Link>
                    );
                } else {
                    return (
                   
                        <Link to="/Profil_karty_platnicze">
                            <a href="" className="btn-primary-responsive margin-top-64">
                                {txt}
                            </a>
                        </Link>
                    );
                }
               
            };

            if (obligatoryDataProvided) {
                const cardInfo = globals.getReadableCreditCardInfo(cardData);
                return (
                    <>
                        <div className="creditcard-added margin-top-32">
                            <div>
                                {cardInfo.length > 0 ? (
                                    <>
                                        <p className="text-large">Zarejestrowałeś kartę</p>

                                        <p className="creditcard-added__card margin-top-8">
                                            {globals.getReadableCreditCardInfo(cardData)}
                                        </p>

                                        <p className="text-large margin-top-8">
                                            i dodałeś ją do swoich płatności.
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <p className="text-large">
                                            Zarejestrowałeś kartę i dodałeś ją do swoich płatności.
                                        </p>
                                    </>
                                )}

                                <p className="text-large">
                                    Od teraz możesz używać jej do opłacania swoich zamówień.
                                </p>
                                <p className="margin-top-32">
                                    Formami płatności możesz zarządzać z poziomu swojego profilu.
                                </p>
                            </div>
                            <div>
                                <svg
                                    className="creditcard-added__icon check-circle-icon"
                                    width="72"
                                    height="72"
                                    viewBox="0 0 72 72"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M29.0947 5.41889C35.6854 3.92981 42.5808 4.61109 48.7527 7.3611C49.7616 7.81066 50.944 7.35719 51.3935 6.34824C51.8431 5.3393 51.3896 4.15694 50.3807 3.70739C43.4209 0.606308 35.6452 -0.161936 28.2132 1.51723C20.7812 3.1964 14.091 7.23301 9.14058 13.025C4.19012 18.8171 1.24458 26.0542 0.743246 33.657C0.241917 41.2599 2.21166 48.8211 6.35872 55.213C10.5058 61.6049 16.6079 66.4851 23.7551 69.1256C30.9023 71.7661 38.7116 72.0255 46.0183 69.8652C53.3249 67.7048 59.7375 63.2404 64.2996 57.1378C68.8618 51.0352 71.329 43.6214 71.3333 36.0021V36.0009V32.9342C71.3333 31.8297 70.4379 30.9342 69.3333 30.9342C68.2288 30.9342 67.3333 31.8297 67.3333 32.9342V35.9998C67.3295 42.7566 65.1416 49.3311 61.0959 54.7428C57.0503 60.1546 51.3636 64.1135 44.8841 66.0293C38.4046 67.9451 31.4794 67.715 25.1413 65.3735C18.8033 63.0319 13.3919 58.7042 9.71433 53.0359C6.03676 47.3676 4.29 40.6624 4.73458 33.9202C5.17915 27.1781 7.79124 20.7603 12.1813 15.6239C16.5713 10.4876 22.5041 6.90796 29.0947 5.41889ZM70.7483 10.7475C71.5289 9.96609 71.5283 8.69976 70.7468 7.9191C69.9654 7.13844 68.6991 7.13907 67.9184 7.92051L35.9993 39.8716L27.4142 31.2865C26.6332 30.5054 25.3668 30.5054 24.5858 31.2865C23.8047 32.0675 23.8047 33.3339 24.5858 34.1149L34.5858 44.1149C34.961 44.4901 35.4699 44.7008 36.0005 44.7007C36.5311 44.7006 37.0399 44.4896 37.4149 44.1142L70.7483 10.7475Z"
                                    />
                                </svg>
                            </div>
                        </div>
                        {btn('ok')}
                    </>
                );
            } else {
                return <>{/* {btn('wróć')} */}</>;
            }
        }
    }

    return render();
};

export default Karta_platnicza_dodano;
